import React from 'react'
import { func } from 'prop-types'

import Print from './Print'

import style from './style'

function StatementViewer (props) {
  const {
    printStatement,
    ...rest,
  } = props

  const value = {
    key: 'SO20180704013',
    statementType: 'sale', // purchase, saleReturn, purchaseReturn
    sender: '管理中心',
    senderAddress: '台北市大安區信義路三段106號4樓',
    senderPhone: '02-27011311',
    senderFAX: '02-27059093',
    recipient: '06-忠孝二店',
    recipientPhone: '02-23581075',
    recipientAddress: '台北市中正區忠孝東路2段16號',
    repairNo: '',
    sendDate: '2018/07/04',
    paymentDate: '2018/07/04',
    CID: '53119626',
    itemNumCount: '共: 57 支 ',
    beforeTax: '$12,810',
    sheetNotice: '無附註事項',
    tax: '$641',
    totalPrice: '$13,451',
    discount: '($0)',
    receivable: '$13,451',
    items: [
      {
        key: 'HR-KS224-12',
        qty: '1',
        name: 'HOORI-KS224-TR90-全框-霧藍-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS7060-6BL',
        qty: '1',
        name: 'HOORI-KS7060-TR90-全框-黑-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS224-11',
        qty: '1',
        name: 'HOORI-KS224-TR90-全框-黑/灰-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS224-4',
        qty: '1',
        name: 'HOORI-KS224-TR90-全框-棕/黃-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS224-2',
        qty: '1',
        name: 'HOORI-KS224-TR90-全框-霧黑-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS7060-2',
        qty: '1',
        name: 'HOORI-KS7060-TR90-全框-霧黑-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-A366-2MBL',
        qty: '1',
        name: 'HOORI-A366-TR90-全框-霧黑-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS224-6',
        qty: '1',
        name: 'HOORI-KS224-TR90-全框-黑-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS7060-7',
        qty: '1',
        name: 'HOORI-KS7060-TR90-全框-紅/粉紅-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-A366-6BL',
        qty: '1',
        name: 'HOORI-A366-TR90-全框-黑-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS233-9',
        qty: '1',
        name: 'HOORI-KS233-TR90-全框-紫-大框一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS233-7',
        qty: '1',
        name: 'HOORI-KS233-TR90-全框-酒紅/粉紅-大框一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS221-11',
        qty: '1',
        name: 'HOORI-KS221-TR90-全框-黑/灰-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS221-14',
        qty: '1',
        name: 'HOORI-KS221-TR90-全框-藍-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS233-4',
        qty: '1',
        name: 'HOORI-KS233-TR90-全框-棕/黃-大框一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-779-7',
        qty: '1',
        name: 'HOORI-779-TR90-全框-紅/粉紅-一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-TR1-3-1',
        qty: '1',
        name: 'HOORI-TR1-3-TR90-全框-黑-長方型',
        unit: '支',
        salePrice: '155',
        subtotal: '155',
        note: '',
      },
      {
        key: 'HR-C804-6',
        qty: '1',
        name: 'HOORI-C804-TR90-全框-黑-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS324-1',
        qty: '1',
        name: 'HOORI-KS324-TR90-全框-黑/灰-橢圓型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-M01-1',
        qty: '1',
        name: 'HOORI-M01-TR90-全框-黑-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-C804-5',
        qty: '1',
        name: 'HOORI-C804-TR90-全框-灰-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-C804-4',
        qty: '1',
        name: 'HOORI-C804-TR90-全框-棕/黃-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-C804-2',
        qty: '1',
        name: 'HOORI-C804-TR90-全框-霧黑-長扁型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-M01-2',
        qty: '1',
        name: 'HOORI-M01-TR90-全框-霧黑-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-779-2',
        qty: '1',
        name: 'HOORI-779-TR90-全框-霧黑-一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-M01-16',
        qty: '1',
        name: 'HOORI-M01-TR90-全框-霧棕-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-779-8',
        qty: '1',
        name: 'HOORI-779-TR90-全框-酒紅-一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-779-6',
        qty: '1',
        name: 'HOORI-779-TR90-全框-黑-一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS324-15',
        qty: '1',
        name: 'HOORI-KS324-TR90-全框-咖啡-橢圓型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-KS221-2',
        qty: '1',
        name: 'HOORI-KS221-TR90-全框-霧黑-長方型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'HR-TR1-3-2',
        qty: '1',
        name: 'HOORI-TR1-3-TR90-全框-霧黑-長方型',
        unit: '支',
        salePrice: '155',
        subtotal: '155',
        note: '',
      },
      {
        key: 'HR-KS233-1',
        qty: '1',
        name: 'HOORI-KS233-TR90-全框-黑-大框一般型',
        unit: '支',
        salePrice: '150',
        subtotal: '150',
        note: '',
      },
      {
        key: 'GB-23308-5',
        qty: '1',
        name: 'GIORGIO BOTTO-23308-純鈦-無邊(思樂)-紅-長方型',
        unit: '支',
        salePrice: '450',
        subtotal: '450',
        note: '',
      },
      {
        key: 'GJ-13266-10',
        qty: '1',
        name: 'GIORGIO VOLANDO-13266-純鈦-無邊(思樂)-黑-長方型',
        unit: '支',
        salePrice: '450',
        subtotal: '450',
        note: '',
      },
      {
        key: 'GJ-13266-1',
        qty: '1',
        name: 'GIORGIO VOLANDO-13266-純鈦-無邊(思樂)-金-長方型',
        unit: '支',
        salePrice: '450',
        subtotal: '450',
        note: '',
      },
      {
        key: 'GJ-13267-10',
        qty: '1',
        name: 'GIORGIO VOLANDO-13267-純鈦-無邊(思樂)-黑-長方型',
        unit: '支',
        salePrice: '450',
        subtotal: '450',
        note: '',
      },
      {
        key: 'GJ-13267-1',
        qty: '1',
        name: 'GIORGIO VOLANDO-13267-純鈦-無邊(思樂)-金-長方型',
        unit: '支',
        salePrice: '450',
        subtotal: '450',
        note: '',
      },
      {
        key: 'GB-23304-8',
        qty: '1',
        name: 'GIORGIO BOTTO-23304-純鈦-無邊(思樂)-槍-長方型',
        unit: '支',
        salePrice: '450',
        subtotal: '450',
        note: '',
      },
      {
        key: 'GB-23358-1',
        qty: '1',
        name: 'GIORGIO BOTTO-23358-純鈦-無邊(思樂)-金-橢圓型',
        unit: '支',
        salePrice: '400',
        subtotal: '400',
        note: '',
      },
      {
        key: 'GB-23304-2',
        qty: '2',
        name: 'GIORGIO BOTTO-23304-純鈦-無邊(思樂)-銀-長方型',
        unit: '支',
        salePrice: '450',
        subtotal: '900',
        note: '',
      },
      {
        key: 'E11-3123-2',
        qty: '1',
        name: 'ECCO-3123-Ultem-全框-紫-長方型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3129-4',
        qty: '1',
        name: 'ECCO-3129-Ultem-全框-藍-方圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3129-5',
        qty: '2',
        name: 'ECCO-3129-Ultem-全框-灰-方圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '500',
        note: '',
      },
      {
        key: 'E11-3109-1',
        qty: '1',
        name: 'ECCO-3109-Ultem-全框-咖啡-長方型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3123-5',
        qty: '1',
        name: 'ECCO-3123-Ultem-全框-灰-長方型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3132-2',
        qty: '1',
        name: 'ECCO-3132-Ultem-全框-藍-長方型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3130-4',
        qty: '1',
        name: 'ECCO-3130-Ultem-全框-藍-長方型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3129-7',
        qty: '1',
        name: 'ECCO-3129-Ultem-全框-藍-方圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3116-3',
        qty: '1',
        name: 'ECCO-3116-Ultem-全框-綠-方圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3108-5',
        qty: '1',
        name: 'ECCO-3108-Ultem-全框-霧灰-橢圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3108-4',
        qty: '1',
        name: 'ECCO-3108-Ultem-全框-綠-橢圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3085-4',
        qty: '1',
        name: 'ECCO-3085-Ultem-全框-霧黑/紅-橢圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3130-6',
        qty: '1',
        name: 'ECCO-3130-Ultem-全框-黑-長方型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3130-5',
        qty: '1',
        name: 'ECCO-3130-Ultem-全框-灰-長方型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
      {
        key: 'E11-3116-2',
        qty: '1',
        name: 'ECCO-3116-Ultem-全框-琥珀-方圓型',
        unit: '支',
        salePrice: '250',
        subtotal: '250',
        note: '',
      },
    ],
  }

  return (
    <div>
      <div className={style.screen}>
        <h3 className={style.pageTitle}>銷貨單{value.key}</h3>

        <div className={style['button-container']}>
          <button className="btn btn-info btn-lg" onClick={printStatement} >列印</button>
        </div>
      </div>
      <Print style={style} {...{ value, rest }} />
    </div>
  )
}

StatementViewer.propTypes = {
  printStatement: func,
}

export default StatementViewer



// WEBPACK FOOTER //
// ./src/components/Statement/Editor.jsx